import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { TbLockPassword, TbDeviceMobileCheck } from "react-icons/tb";
import { AiOutlineEyeInvisible } from "react-icons/ai";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import toast from "react-hot-toast";
import HttpClient from "../../Services/HttpClient";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { mobileNo } = useParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passIcon, setPassIcon] = useState(false);

  const emailRef = useRef(null);
  const passwordRef = useRef(null);

  const EyeIconPass = passIcon ? MdOutlineRemoveRedEye : AiOutlineEyeInvisible;

  const validatePassword = (pass) => {
    if (!pass) return "Enter password";
    if (!/[A-Z]/.test(pass)) return "Password must contain uppercase letters";
    if (!/[a-z]/.test(pass)) return "Password must contain lowercase letters";
    if (!/[0-9]/.test(pass)) return "Password must contain numbers";
    if (pass.length < 8) return "Password must be at least 8 characters";
    if (!/[!*@#%&()^~{}]/.test(pass))
      return "Password must contain a special character";
    return "";
  };

  const handleLogin = () => {
    let valid = true;

    // EMAIL VALIDATION
    if (email.length === 0) {
      setEmailError("Email is required");
      emailRef.current.focus();
      valid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setEmailError("Please enter a valid email address");
      emailRef.current.focus();
      valid = false;
    } else {
      setEmailError("");
    }


    // navigate("/reset-password");

    if (!valid) return;

    let payload = new FormData();
    payload.append("email", email);
    post(URLS.FORGET_PASSWORD, payload)
      .then((res) => {
        if (res?.status == "success") {
         toast.success(res?.message || 'Password reset link sent to your email.')
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const keydownHandler = (event) => {
    if (event.key == "Enter") {
      handleLogin();
    }
  };

  useEffect(() => {
    if (localStorage.getItem("token")) {
      navigate("/general-user");
    }
  }, []);

  return (
    <div className="container-fluid">
      <div className="row vh-100">
        <div
          className="col-lg-6 col-md-6 col-12 p-0"
          style={{ height: "100vh" }}
        >
          <div
            style={{
 backgroundImage: "url(https://khyathi-bucket-store.s3.us-east-1.amazonaws.com/loginLogo.png)",
              backgroundSize: "100% 100%",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              height: "100%",
              width: "100%",
            }}
          ></div>
        </div>

        <div style={{ height: '100vh' }} className="col-lg-6 col-md-6 col-12 d-flex flex-column justify-content-end align-items-center bg-white text-white">
          <div style={{
            height: '62%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
          }} className="w-60">
            <h2 className="mb-3 f8 text-left fs-5 text-black">Forgot Password</h2>

            {/* Email INPUT */}
            <div className="mb-3">
              <label className="form-label">Email ID</label>
              <div className="mb-3">
                <div className="position-relative mb-1">


                  {/* PASSWORD INPUT */}
                  <input
                    type="email"
                    className={`form-controlpass ${emailError ? "border border-danger" : ""
                      }`}
                    placeholder="Enter your Email ID"
                    value={email}
                    ref={emailRef}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setEmailError("");
                    }}
                    onKeyDown={keydownHandler}
                    style={{
                      borderRadius: "8px",
                      border: "1px solid #666",
                      height: "46px",
                      paddingLeft: "20px",
                      paddingRight: "20px",
                    }}
                  />
                </div>
                {emailError && (
                  <small className="text-danger">{emailError}</small>
                )}
              </div>
            </div>



            <button
              style={{ backgroundColor: "#259AF9" }}
              className="btn  w-100 text-white border-rounded  d-block py-2 fw-bold"
              onClick={handleLogin}
            >
              Submit
            </button>
          </div>
          <div
            style={{
              // backgroundImage: `url(${require("../../common/Assets/imgs/bgLogin.png")})`,
              background:"url(https://khyathi-bucket-store.s3.us-east-1.amazonaws.com/bgLogin.png)" ,
              height: "38%",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }} className="w-100" ></div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
